import { LEAD_STATUSES } from "@/lib/constants";

export default function LeadStatusBadge({ status, size = "sm" }) {
  const meta = LEAD_STATUSES.find((s) => s.value === status) || LEAD_STATUSES[0];
  const padding = size === "sm" ? "px-2 py-0.5" : "px-3 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${padding} border text-[11px] font-mono uppercase tracking-wider`}
      style={{ borderColor: meta.color, color: meta.color }}
    >
      <span className="w-1.5 h-1.5" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
}
